<template>
    <div class="content-wrapper html-block" v-html="content"></div>
</template>

<script>

//todo sanitizer
export default {
    name: 'HtmlRenderer',
    props: {
        content: String,
    },
};
</script>

<style scoped>
    .content-wrapper{
        display: inline;
    }
</style>